import {
  bookTicketApi,
  CheckPhoneApi,
  countCardsApi,
  createCardApi,
  detectImagesApi,
  detectTextApi,
  exchangeCodeApi,
  getAllCardsApi,
  getCampaignInfoApi,
  GetDistrictsApi,
  GetMartsApi,
  getProvincesApi,
  getSlotsApi,
  OTPLogApi,
  requestGigyaApi,
  requestLoginApi,
  requestSMSOTPApi,
  topupMobileApi,
  UpdateDeliveryApi,
  updateUserInfoApi,
  verifyOTPApi,
} from "api/home";
import { call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import actions from "./actions";
import {
  BOOK_TICKET,
  CHECK_PHONE,
  COUNT_CARDS,
  CREATE_CARD,
  DETECT_IMAGE,
  DETECT_TEXT,
  EXCHANGE_CODE,
  GET_CAMPAIGN_INFO,
  GET_CARDS,
  GET_DISTRICTS,
  GET_MARTS,
  GET_PROVINCES,
  GET_SLOTS,
  OTP_LOG,
  REQUEST_GIGYA,
  REQUEST_LOGIN,
  REQUEST_SMS_OTP,
  TOPUP_MOBILE,
  UPDATE_DELIVERY,
  UPDATE_USER_INFO,
  VERIFY_OTP,
} from "./constants";

export function* getProvincesSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getProvincesApi, payload);
    yield put(actions.GET_PROVINCES.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_PROVINCES.failure(err));
  }
}

export function* requestSMSOTPSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestSMSOTPApi, payload);
    yield put(actions.REQUEST_SMS_OTP.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_SMS_OTP.failure(err));
  }
}

export function* OTPLogSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(OTPLogApi, payload);
    yield put(actions.OTP_LOG.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.OTP_LOG.failure(err));
  }
}

export function* verifyOTPSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(verifyOTPApi, payload);
    yield put(actions.VERIFY_OTP.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.VERIFY_OTP.failure(err));
  }
}

export function* requestLoginSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestLoginApi, payload);
    yield put(actions.REQUEST_LOGIN.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_LOGIN.failure(err));
  }
}

export function* updateUserInfoSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(updateUserInfoApi, payload);
    yield put(actions.UPDATE_USER_INFO.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.UPDATE_USER_INFO.failure(err));
  }
}

export function* requestGigyaSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(requestGigyaApi, payload);
    yield put(actions.REQUEST_GIGYA.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.REQUEST_GIGYA.failure(err));
  }
}

export function* exchangeCodeSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(exchangeCodeApi, payload);
    yield put(actions.EXCHANGE_CODE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.EXCHANGE_CODE.failure(err));
  }
}

export function* topupMobileSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(topupMobileApi, payload);
    yield put(actions.TOPUP_MOBILE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.TOPUP_MOBILE.failure(err));
  }
}

export function* GetDistrictsSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(GetDistrictsApi, payload);
    yield put(actions.GET_DISTRICTS.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_DISTRICTS.failure(err));
  }
}

export function* GetMartsSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(GetMartsApi, payload);
    yield put(actions.GET_MARTS.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_MARTS.failure(err));
  }
}

export function* UpdateDeliverySaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(UpdateDeliveryApi, payload);
    yield put(actions.UPDATE_DELIVERY.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.UPDATE_DELIVERY.failure(err));
  }
}

export function* CheckPhoneSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(CheckPhoneApi, payload);
    yield put(actions.CHECK_PHONE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.CHECK_PHONE.failure(err));
  }
}
export function* getSlotsSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getSlotsApi, payload);
    yield put(actions.GET_SLOTS.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_SLOTS.failure(err));
  }
}
export function* bookTicketSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(bookTicketApi, payload);
    yield put(actions.BOOK_TICKET.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.BOOK_TICKET.failure(err));
  }
}
//PS 8-3
export function* getCampaignInfoSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getCampaignInfoApi, payload);
    yield put(actions.GET_CAMPAIGN_INFO.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_CAMPAIGN_INFO.failure(err));
  }
}
export function* getCardsSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(getAllCardsApi, payload);
    yield put(actions.GET_CARDS.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.GET_CARDS.failure(err));
  }
}
export function* countCardSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(countCardsApi, payload);
    yield put(actions.COUNT_CARDS.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.COUNT_CARDS.failure(err));
  }
}
export function* detectImageSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(detectImagesApi, payload);
    yield put(actions.DETECT_IMAGE.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.DETECT_IMAGE.failure(err));
  }
}
export function* detectTextSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(detectTextApi, payload);
    yield put(actions.DETECT_TEXT.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.DETECT_TEXT.failure(err));
  }
}
export function* createCardSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(createCardApi, payload);
    yield put(actions.CREATE_CARD.success(res?.data));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.CREATE_CARD.failure(err));
  }
}

function* watchCommon() {
  yield takeLatest(GET_PROVINCES.request, getProvincesSaga);
  yield takeLatest(REQUEST_SMS_OTP.request, requestSMSOTPSaga);
  yield takeLatest(OTP_LOG.request, OTPLogSaga);
  yield takeLatest(VERIFY_OTP.request, verifyOTPSaga);
  yield takeLatest(REQUEST_LOGIN.request, requestLoginSaga);
  yield takeLatest(UPDATE_USER_INFO.request, updateUserInfoSaga);
  yield takeLatest(REQUEST_GIGYA.request, requestGigyaSaga);
  yield takeLatest(EXCHANGE_CODE.request, exchangeCodeSaga);
  yield takeLatest(TOPUP_MOBILE.request, topupMobileSaga);
  yield takeLatest(GET_DISTRICTS.request, GetDistrictsSaga);
  yield takeLatest(GET_MARTS.request, GetMartsSaga);
  yield takeLatest(UPDATE_DELIVERY.request, UpdateDeliverySaga);
  yield takeLatest(CHECK_PHONE.request, CheckPhoneSaga);
  yield takeLatest(GET_SLOTS.request, getSlotsSaga);
  yield takeLatest(BOOK_TICKET.request, bookTicketSaga);
  yield takeLatest(GET_CAMPAIGN_INFO.request, getCampaignInfoSaga);
  yield takeEvery(GET_CARDS.request, getCardsSaga);
  yield takeLatest(COUNT_CARDS.request, countCardSaga);
  yield takeLatest(DETECT_IMAGE.request, detectImageSaga);
  yield takeLatest(DETECT_TEXT.request, detectTextSaga);
  yield takeLatest(CREATE_CARD.request, createCardSaga);
}

export default function* rootChild() {
  yield fork(watchCommon);
}
